/** @jsx jsx */
import { jsx } from 'theme-ui';
import BaseProductsTemplate from '@bottlebooks/gatsby-theme-event-pages/src/templates/ProductsTemplate';
import { graphql as gatsbyGraphQL } from 'gatsby';
import addPriceRange from '../../../addPriceRange';

export * from '@bottlebooks/gatsby-theme-event-pages/src/templates/ProductsTemplate';

export default function ProductsTemplate({
  data,
  pageContext,
  location,
  navigate,
}) {
  // console.log(afterQuery(data));
  return (
    <BaseProductsTemplate
      data={afterQuery(data)}
      pageContext={pageContext}
      location={location}
      navigate={navigate}
    />
  );
}

export const pageQuery = gatsbyGraphQL/* GraphQL */ `
  fragment vv_ProductProducerLogo on Bottlebooks_Product {
    producer {
      logo {
        fixed(
          width: 184
          height: 184
          crop: PAD
          background: "#FFF0"
          quality: BEST
        ) {
          src
          height
          width
          base64
        }
      }
    }
  }
  query vv_ProductsTemplate(
    $eventId: ID!
    $locale: Bottlebooks_ContentLocale
    $filter: ProductFilterInput
    $sort: ProductSortInput
    $localeString: String
  ) {
    bottlebooks {
      event(eventId: $eventId, locale: $locale) {
        collectionId: eventId
        ...bb_ProductsPageBase_Collection
        registeredProducts {
          nodes {
            productId
            pricing {
              price
            }
            registration {
              ...vv_Registration_exhibitorPackage
            }
            ...bb_ProductsPageBase
            ...vv_productFilters
            product {
              __typename
              ...vv_ProductProducerLogo
              ...vv_ProductName
              ...vv_ProductVarieties
            }
          }
        }
      }
    }

    firstProducts: allProduct(filter: $filter, sort: $sort, limit: 10) {
      nodes {
        ...ProductsPage_first
      }
    }
    products: allProduct(filter: $filter, sort: $sort) {
      nodes {
        productId
        slug
        exhibitor {
          slug
        }
        ...ProductsPage
      }
    }
    event(locale: { eq: $localeString }) {
      ...ProductsPage_Event
      filterPriceRange
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`;

function afterQuery(data) {
  return {
    ...data,
    bottlebooks: {
      ...data?.bottlebooks,
      event: {
        ...data?.bottlebooks?.event,
        registeredProducts: {
          ...data?.bottlebooks?.event?.registeredProducts,
          nodes: data?.bottlebooks?.event?.registeredProducts?.nodes.map(
            (registeredProduct) =>
              wipePremiumData({
                ...registeredProduct,
                price: undefined,
                pricing: addPriceRange(registeredProduct.pricing),
                product: {
                  ...registeredProduct.product,
                  __typename: registeredProduct.product.__typename.replace(
                    'Bottlebooks_',
                    ''
                  ),
                },
              })
          ),
        },
      },
    },
  };
}

function wipePremiumData(registeredProduct) {
  const exhibitorPackage =
    registeredProduct?.registration?.exhibitorPackage?.key;
  if (exhibitorPackage === 'premium' || exhibitorPackage === 'pavilion') {
    return registeredProduct;
  }
  const { offeringTypes, ...rest } = registeredProduct;
  return { ...rest, features: null };
}
